import React, { useState, useEffect } from "react";
import WithdrawalForm from "../../../components/WithdrawalForm/WithdrawalForm";
import AddressInfo from "../../../components/AddressInfo/AddressInfo";
import { useDispatch, useSelector } from "react-redux";
import {
    resetUpdateAndErrors,
    requestWithdrawFundsAsync,
    resetUserAccountProfileState
} from "../../../stores/account/account.slice";
import './WithdrawFundsView.style.scss';
import {FormattedMessage, useIntl} from "react-intl";
import GlobalConst from "../../../constants/GlobalConst";
import {selectUserAccount, selectUserAccountProfileState} from "../../../stores/account/account.selectors";
import {withdrawFundsAsync} from "../../../stores/account/account.thunks";
import UserAccountUpdatedPopUp from "../../PopUps/UserAccountUpdateSuccess/UserAccountUpdatedPopUp";
import useAppModalService from "../../../hooks/useAppModalService";
import Currency from "../../../components/Currency/Currency";

const WithdrawFundsView = () => {
    const [withdrawAmount, setWithdrawAmount] = useState(null);
    const [withdrawFundsErrorMsg, setWithdrawFundsErrorMsg] = useState([]);
    const dispatch = useDispatch();
    const {openModal} = useAppModalService();
    const intl = useIntl();
    window.scrollTo(0, 0);
    const account = useSelector(selectUserAccount);
    const userAccountProfileState = useSelector(selectUserAccountProfileState);
    const canWithdraw = (GlobalConst.FEATURES.DOTFR ?
                                                    account.availableEuro
                                                    :
                                                    account.availableCash) >= GlobalConst.MIN_WITHDRAW_AMOUNT;

    useEffect(() => {
        setWithdrawFundsErrorMsg([]);
    }, [withdrawAmount]);

    useEffect( () => {
        if(userAccountProfileState.updated){
            openModal('userAccountUpdated', 'info', {
                title: <FormattedMessage id={`popUp.${userAccountProfileState.eventName}.title`}/>,
                subtitle: <FormattedMessage id={`popUp.${userAccountProfileState.eventName}.subTitle`}/>,
                modalComponent: UserAccountUpdatedPopUp,
                onClose: () => {
                    dispatch(resetUserAccountProfileState());
                },
                onOk: () => {
                    dispatch(resetUserAccountProfileState());
                }
            });
        }

    }, [userAccountProfileState.updated]);

    const handleWithdrawFunds = () => {
        const { address } = account;
        const errors = [];

        if (!address?.address1 || !address?.country || !address?.state || !address?.zipCode) {
            errors.push(intl.formatMessage({ id: 'myAccountView.withdrawFunds.provideAddress' }));
        }

        if (withdrawAmount < GlobalConst.MIN_WITHDRAW_FUNDS) {
            errors.push(intl.formatMessage({ id: 'myAccountView.withdrawFunds.minimumWithdrawalAmount'}, {amount: <Currency value={GlobalConst.MIN_WITHDRAW_FUNDS} removeDecimal/>}));
        }

        if (isNaN(withdrawAmount)) {
            errors.push(intl.formatMessage({ id: 'myAccountView.withdrawFunds.mustBeValidAmount' }));
        }

        if (parseInt(withdrawAmount) % 5 !== 0) {
            errors.push(intl.formatMessage({ id: 'myAccountView.withdrawFunds.multipleOf5Amount' }));
        }

        if (errors.length > 0) {
            setWithdrawFundsErrorMsg(errors);
            return;
        }

        let currency = "US";
        if (GlobalConst.FEATURES.DOTFR)
            currency = "EUR";
        if (GlobalConst.FEATURES.DOTMX)
            currency = "MXN";


        dispatch(withdrawFundsAsync({ accountId: account.accountId, amount: withdrawAmount, currency }));
    };

    return (
        <div className="WithdrawFundsView">
            <div className="withdrawFundsTitle gold-gradient-text">
                <FormattedMessage id="myAccountView.withdrawFunds.title" />
            </div>
            <div className="withdrawalNote">
                <FormattedMessage id="myAccountView.withdrawFunds.subTitle" />
            </div>
            {withdrawFundsErrorMsg.length > 0 && (
                <div className="validation-summary-errors">
                    <ul>
                        {withdrawFundsErrorMsg.map((msg, index) => (
                            <li key={`error${index}`}>{msg}</li>
                        ))}
                    </ul>
                </div>
            )}
            <div className="withdrawFundsContent">
                <AddressInfo />
                <WithdrawalForm
                    amount={withdrawAmount}
                    onAmountChange={setWithdrawAmount}
                    onSubmit={handleWithdrawFunds}
                    canWithdraw={canWithdraw}
                />
            </div>
        </div>
    );
};

export default WithdrawFundsView;
